import React from 'react';
import Radio from 'relements/build/esm/input/radio';
import { isProduction } from '@src/utils';
import styles from './PromptTriggerEditView.scss';

function PromptRuleTypes({
  options,
  value,
  onChange,
  text = '',
  isTask = false,
}) {
  return (
    <div className={styles.promptVariantsWrapper}>
      <div
        className={isTask ? styles.taskVariantTitle : styles.promptVariantTitle}
      >
        {text}
      </div>
      <Radio
        disabled={isProduction()}
        className={styles.noMarginRadio}
        options={options}
        value={value}
        onChange={(option) => onChange(option)}
      />
    </div>
  );
}

export default PromptRuleTypes;
